import { useEffect, useState } from 'react';

export const useScreenUtils = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    function handleResize() {
      const isMobileScreen = !!(window?.innerWidth < 768);
      setIsMobile(isMobileScreen);
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    isMobile,
  };
};
